import { I18n } from './i18n.interface';

export const initialState: I18n = {
  loaded: false,
  loading: false,
  saved: false,
  saving: false,
  multisave: false,
  valid: false,
  json: null,
  allCsv: null,
  allJson: null,
  referenceJson: null,
  languageCode: null,
  dataChanged: false,
};
